/**
 * Impersonation Service - API methods for platform admin impersonation
 * Endpoints:
 *   POST /api/v1/platform/impersonation/start
 *   POST /api/v1/platform/impersonation/end
 */

import apiClient from './apiClient';

export interface StartImpersonationRequest {
  targetUserId: string;
  reason?: string;
}

export interface StartImpersonationResponse {
  impersonationToken: string;
  sessionId: string;
  expiresAt: string; // ISO 8601
}

export interface EndImpersonationRequest {
  sessionId: string;
}

export const startImpersonation = async (
  targetUserId: string,
  reason?: string,
): Promise<StartImpersonationResponse> => {
  const body: StartImpersonationRequest = { targetUserId };
  if (reason) body.reason = reason;

  const response = await apiClient.post<{ success: boolean; data: StartImpersonationResponse }>(
    '/api/v1/platform/impersonation/start',
    body,
  );
  return response.data.data;
};

export const endImpersonation = async (sessionId: string): Promise<void> => {
  await apiClient.post('/api/v1/platform/impersonation/end', { sessionId } satisfies EndImpersonationRequest);
};
